<template>
  <div id="content">
    <h2>My Orders</h2>
    <b-row>
      <b-col>
        Search and view your orders.  Orders can be filtered by status, date ordered, or date the order was closed.
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <form-group label="Order Status" :validator="$v.criteria.statuses">
          <b-form-checkbox-group
              stacked
              v-model="criteria.statuses"
              :options="statusOptions"
              text-field="description"
              value-field="code"
          ></b-form-checkbox-group>
        </form-group>
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <BaseTypableDateInput
                v-model="criteria.orderDateStart"
                :v="$v.criteria.orderDateStart"
                slug="orderDateStart"
                label="Order Date Start"
                :messages="dateMessages"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <BaseTypableDateInput
                v-model="criteria.orderDateEnd"
                :v="$v.criteria.orderDateEnd"
                slug="orderDateEnd"
                label="Order Date End"
                :messages="dateMessages"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <BaseTypableDateInput
                v-model="criteria.completeDateStart"
                :v="$v.criteria.completeDateStart"
                slug="completeDateStart"
                label="Order Closed Date Start"
                :messages="dateMessages"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <BaseTypableDateInput
                v-model="criteria.completeDateEnd"
                :v="$v.criteria.completeDateEnd"
                slug="completeDateEnd"
                label="Order Closed Date End"
                :messages="dateMessages"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col offset="10">
        <b-button type="button" variant="primary" @click="search">Search</b-button>
      </b-col>
      <b-col>
        <b-button type="button" variant="secondary" @click="clear">Clear</b-button>
      </b-col>
    </b-row>
    <b-row class="pt-3 mt-3 border-top">
      <b-col>
        <h3>Results</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <OrdersTable :items="orders" v-on:delete-order="deleteSuccess" modalId="search" v-on:order-emit="$emit('update-order')"/>
      </b-col>
    </b-row>
  </div>

</template>
<script>


import axiosRetry from 'axios-retry'
import axios from "axios"
import LocalStorageService from "@/common/LocalStorageService";
import BaseTypableDateInput from "@/components/templates/input/BaseTypableDateInput.vue";
import {minLength, required} from "vuelidate/lib/validators";
import maxDate from "@/validators/maxDate";
import minDate from "@/validators/minDate";
import {toastService} from "@/mixins/toastService";
import OrdersTable from "@/components/templates/display/OrdersTable.vue";

axiosRetry(axios, { retries: 3,
  retryDelay: axiosRetry.exponentialDelay  });

const localStorageService = LocalStorageService.getService();


export default {
  components: {
    OrdersTable,
    BaseTypableDateInput
  },
  data: () => {
    return {
      criteria: {
        statuses: ['PAID', 'PROCESS', 'SHIPPED'],
        orderDateStart: null,
        orderDateEnd: null,
        completeDateStart: null,
        completeDateEnd: null,
      },
      statusOptions: [],
      dateMessages: {
        maxDate: 'Date cannot be in the future.',
        minDate: 'Dates before 01/01/1900 are not searchable.'
      },
      orders: [],
    }
  },
  mounted() {
    this.fetchStatusOptions();
    this.search();
  },
  methods: {
    fetchStatusOptions() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/options/status`)
          .then(response=>{
            this.statusOptions = response.data
          })
    },
    search() {
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/order/search`, this.criteria)
          .then(response=> {
            this.orders = response.data
          })
          .catch(err => {
            toastService.showRootToast("Error", "An error has occurred while searching" , "danger", this.$root)
          })
    },
    clear() {
      this.criteria = {
        statuses: [],
        orderDateStart: null,
        orderDateEnd: null,
        completeDateStart: null,
        completeDateEnd: null,
      }
    },
    deleteSuccess() {
      toastService.showRootToast("Success", "Order Cancelled", "success", this.$root)
      this.search()
    },
  },
  validations() {
    return {
      criteria: {
        statuses: {
          required,
          minLength: minLength(1)
        },
        orderDateStart: {
          required:false,
          maxDate: maxDate(new Date()),
          minDate: minDate(new Date('1900-01-01'))
        },
        orderDateEnd: {
          required:false,
          maxDate: maxDate(new Date()),
          minDate: minDate(new Date('1900-01-01'))
        },
        completeDateStart: {
          required:false,
          maxDate: maxDate(new Date()),
          minDate: minDate(new Date('1900-01-01'))
        },
        completeDateEnd: {
          required:false,
          maxDate: maxDate(new Date()),
          minDate: minDate(new Date('1900-01-01'))
        },
      }
    }
  },
  created() {
    document.title = "My Orders - Online Storefront"
  },
}
</script>

<style>
h5 {
  font-weight: bold;
  font-family: inherit;
}
</style>
